// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2xlPw","signatureBlock":"Footer_signatureBlock__nZJYk","signature":"Footer_signature__3GsaL"};